import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
`

export const Content = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
`
